import DomUtil, { ReplaceMode } from '../../../../core/util/dom_util';
import { ItemRefineSearchAction } from "../../../actions/item_refine_search/item_refine_search_action";
import { ItemRefineSearch } from "../../../models/item_refine_search/item_refine_search";
import { SubstituteItemAreaAction } from '../../../../core/actions/substitute_item/substitute_item_area_action';
import { AddRecommendationItemContainer } from '../../../../search/addRecommendationItem/views/pc/add_recommendation_item_container';
import { AddRecommendationItemAction } from '../../../../search/addRecommendationItem/actions/add_recommendation_item_action';
import { JsEnv, isSoloare } from '../../../models/js_env';
import { ComparisonTableAction } from '../../../actions/comparison_table/comparison_table_action'
import { BulkAddCartAction } from '../../../actions/add_cart/bulk_add_cart_action';
import { Env } from '../../../env';

// 新しい画面に代替する際に、要素内を置換するエリア
const replaceInsideAreaSelectors = [
  // カテゴリで絞り込むパーツ（中小カテトップ／キーワード検索結果で同じid属性を利用する）
  "#itemRefineSearch-categoryRefine",
  // 左サイド「条件で絞り込む」のタイトル　および 対応するメガドロップ追従エリア
  "#itemRefineSearch-refineTitle",
  "#itemRefineSearch-refineTitle-followParts",
  // 左サイドスペックで絞り込むパーツ　および 対応するメガドロップ追従エリア
  "#itemRefineSearch-specRefine",
  "#itemRefineSearch-specRefine-followParts",
  // お届け日目安で絞り込むパーツ　および 対応するメガドロップ追従エリア
  "#itemRefineSearch-deliveryDateRefine",
  "#itemRefineSearch-deliveryDateRefine-followParts",
  // メーカーから絞り込むパーツ　および 対応するメガドロップ追従エリア
  "#itemRefineSearch-makerRefine",
  "#itemRefineSearch-makerRefine-followParts",
  // ブランドから絞り込むパーツ　および 対応するメガドロップ追従エリア
  "#itemRefineSearch-brandRefine",
  "#itemRefineSearch-brandRefine-followParts",
  // シリーズから絞り込むパーツ　および 対応するメガドロップ追従エリア
  "#itemRefineSearch-seriesRefine",
  "#itemRefineSearch-seriesRefine-followParts",
  // 価格で絞り込むパーツ　および 対応するメガドロップ追従エリア
  "#itemRefineSearch-priceRefine",
  "#itemRefineSearch-priceRefine-followParts",
  // お得な商品で絞り込むパーツ　および 対応するメガドロップ追従エリア
  "#itemRefineSearch-beneficialItemRefine",
  "#itemRefineSearch-beneficialItemRefine-followParts",
  // 商品の種類で絞り込むパーツ　および 対応するメガドロップ追従エリア
  "#itemRefineSearch-itemTypeRefine",
  "#itemRefineSearch-itemTypeRefine-followParts",
  // 除外する商品パーツ　および 対応するメガドロップ追従エリア
  "#itemRefineSearch-excludeItemRefine",
  "#itemRefineSearch-excludeItemRefine-followParts",
  // 小カテゴリーエリア（WEB/メーカーの中カテトップのみ）
  "#itemRefineSearch-sCategoriesRefine",
  // メインエリアスペックで絞り込むパーツ
  "#itemRefineSearch-mainAreaSpecRefine",
  // メインエリア特徴的なスペックスペックで絞り込むパーツ
  "#itemRefineSearch-characteristicSpecRefine",
  // 商品表示エリアヘッダーパーツ
  "#itemRefineSearch-searchResultHeader",
  // 商品表示エリアヘッダー 環境対応商品表示パーツ
  "#itemRefineSearch-ecoFriendlyProductsNotice",
  // 商品表示エリアヘッダー 絞り込みパーツ
  "#itemRefineSearch-refinedConditions",
  // 商品表示エリアボディーパーツ
  "#itemRefineSearch-searchResultBody",
  // ページャー
  "#itemRefineSearch-pager",
  // 代替品エリア（キーワード検索結果画面のみ）
  "#itemRefineSearch-substituteItem",
  // キーワード絞り込みエリア（キーワード検索結果画面のみ）
  "#itemRefineSearch-keywordRefine",
  // タグのタイトル
  "#itemRefineSearch-title",
  // パプリリンクエリア（キーワード検索結果画面のみ）
  "#itemRefineSearch-papuriLinkRefine",
  // パンくずエリア
  "#breadcrumbArea",
  // Criteoスクリプト
  "#criteo-script",
  // 関連語エリア
  "#morphemeArea",
  // 0件時メッセージ
  "#searchNote",
  // 外部ファイルエリア
  "#external-file-bottom"
];

// 新しい画面に代替する際に、要素そのものを置換するエリア
const replaceItselfAreaSelectors = [
  // カノニカル
  "#itemRefineSearch-canonical",
  // meta description
  "#itemRefineSearch-description",
];

const replaceSpecs = replaceInsideAreaSelectors.map(id => {return {selector: id, replaceMode: ReplaceMode.INSIDE_OF_TARGET}})
                                .concat(replaceItselfAreaSelectors.map(id => {return {selector: id, replaceMode: ReplaceMode.TARGET_ITSELF}}));                           

export class ItemRefineSearchContainer {
  constructor(model: ItemRefineSearch) {
    ItemRefineSearchAction.UPDATE_EVENT.on(this.refreshDOMAndCallInitScripts.bind(this));
    window.addEventListener('load', function () {
      ItemRefineSearchContainer.setAnalytics(model);
    });
  }

  private refreshDOMAndCallInitScripts(model: ItemRefineSearch) {
    const newHtml = model.getModel().htmlForRender!; // newHtmlは非Null

    const isSoloareLogin =
      Env.PAGE.isLogin && Env.PAGE.userId
        ? isSoloare(Env.SITE_TYPE) &&
          (Env.PAGE.isLogin as boolean) &&
          (Env.PAGE.userId as string) !== '' &&
          document.getElementById('thinHeader') != null
        : false;

    // ソロアリでログイン中の場合、絞り込み後のスクロールをDomUtil内の処理を使わず下の処理で行う
    const scrollTarget = isSoloareLogin ? undefined : '#itemRefineSearch-refinedConditions';

    if (isSoloareLogin) {
      // 画面の他のJS優先初期化させるためにsetTimeout
      setTimeout(() => {
        const selector = document.querySelector('#itemRefineSearch-refinedConditions');
        if (selector) {
          // ソロアリでログイン中の場合、スクロール先を追従ヘッダの下に位置するように移動
          window.scroll({ top: selector.getBoundingClientRect().top + window.scrollY - 47 });
        }
      }, 0);
    }

    DomUtil.replaceByReplaceSpec(
      newHtml,
      // どのエリアをどのモードで差し替えるかを指定できるようにする
      replaceSpecs.filter(it => document.querySelector(it.selector)),
      {
        reInitAll: true,
        // 商品表示エリアヘッダー 絞り込みパーツへスクロール
        scrollIntoAnchorSelector: scrollTarget,
        onJsEnvLoaded: (newJsEnv: JsEnv) => {
          AddRecommendationItemAction.init(newJsEnv, AddRecommendationItemContainer);
        }
      }
    );

    // 比較表関連の初期化を行う。
    ComparisonTableAction.reInit();

    // バリエーション共通スペックモーダルの一括カゴ追加ボタン初期化
    BulkAddCartAction.reInit();

    // メガドロップのCX JSを初期化
    if ((window as any)._megadropManager) {
      // CX側オブジェクトが存在する場合のみ初期化する。
      new (window as any)._megadropManager(); // NOSONAR
    }

    /*
    //TODO Adobe Analytics TATTR-8167 で対応
    document.querySelector('#itemRefineSearch-canonical')!.innerHTML = model.querySelector('#itemRefineSearch-canonical')!.innerHTML;
    document.querySelector('#itemRefineSearch-robots')!.innerHTML = model.querySelector('#itemRefineSearch-robots')!.innerHTML;
    */

    // スピンを非表示
    model.hideLoadingSpinner();
    ItemRefineSearchContainer.setAnalytics(model);
  }

  static setAnalytics(model: ItemRefineSearch) {
    /// キーワード検索画面
    if (model.isKeywordSearch() || model.isLKeywordSearch()) {
      SubstituteItemAreaAction.setAnalyticsItems(
        'keyword',
        '#itemRefineSearch-searchResultBody .o-itemdescription.-hasBorder.-border-line, .m-itemcard',
        '.a-box.-carouselWrap.-bordered, .m-tooltipContent [data-substitute-catalog-item-code]'
      );
      /// カテゴリー検索画面
    } else if (model.isCategoryMSearch() || model.isCategorySSearch()) {
      SubstituteItemAreaAction.setAnalyticsItems(
        'category',
        '#itemRefineSearch-searchResultBody .o-itemdescription.-hasBorder.-border-line, .m-itemcard',
        '.a-box.-carouselWrap.-bordered, .m-tooltipContent [data-substitute-catalog-item-code]'
      );
    }
  }
}
